/* Galenée addons: scroll-in animation observer */
(function () {
  var els = document.querySelectorAll('[data-anim]');
  if (!('IntersectionObserver' in window) || !els.length) {
    els.forEach && els.forEach(function (el) { el.classList.add('anim-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('anim-in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  els.forEach(function (el) { io.observe(el); });
})();
